import Joi from 'joi';

export const ProvinceTaskSchema = Joi.object({
  name: Joi.string().required(),
  description: Joi.string().required(),
  provinceTaskDate: Joi.date().required(),
});

export const ProvinceTaskAttachmentSchema = Joi.object({
  name: Joi.string().required(),
  file: Joi.string().required(),
});
